<template>
  <div class="fit-to-content">
    <i-input v-model="searchData" style="width: 400px;margin-bottom: 16px;">
      <Select v-model="searchBy" slot="prepend" style="width: 100px">
        <Option value="T">Title</Option>
        <Option value="A">Author</Option>
      </Select>
      <Button
        slot="append"
        icon="ios-search"
        @click.native="getGameList(1)"
      ></Button>
    </i-input>
    <Table
      :columns="columns"
      :loading="dataLoading"
      :data="games"
      :row-class-name="RowClassName"
      @on-row-dblclick="showInfo"
      width="1040"
      height="600"
    >
      <div slot-scope="{ row, index }" slot="title">
        <span>{{ row.gameRef.gameTitle }}</span>
      </div>
      <div slot-scope="{ row, index }" slot="author">
        <span>{{ row.gameRef.author }}</span>
      </div>
      <div slot-scope="{ row, index }" slot="action">
        <Button type="error" size="small" @click="remove(row)">Delete</Button>
      </div>
    </Table>
    <Page
      ref="paginator"
      :total="dataCount"
      show-sizer
      @on-change="pageChanged"
      @on-page-size-change="pageSizeChanged"
      class="right"
      style="margin-top: 16px;"
    />
    <GameInfoModal ref="gameInfoModal"></GameInfoModal>
  </div>
</template>

<script>
import GameInfoModal from "./GameInfoModal";
import { bus } from "../../main";
import { getGames, deleteGame } from "../../_services/game.service";

export default {
  components: {
    GameInfoModal
  },
  data() {
    return {
      searchData: "",
      searchBy: "T",
      columns: [
        {
          title: "Title",
          slot: "title",
          width: 268
        },
        {
          title: "Author",
          slot: "author",
          width: 280
        },
        {
          title: "Description",
          key: "description",
          width: 400
        },
        {
          title: " ",
          slot: "action",
          width: 90,
          align: "right"
        }
      ],
      dataCount: 10,
      currentPage: 1,
      rowSize: 10,
      games: [],
      activeRow: null,
      dataLoading: true
    };
  },
  methods: {
    getGameList(page) {
      if (page) {
        this.$refs.paginator.changePage(page);
        this.currentPage = page;
      }
      this.dataLoading = true;
      let offset = 0;
      if (this.currentPage > 1) {
        offset = (this.currentPage - 1) * this.rowSize;
      }
      let params = {
        Offset: offset,
        MaxResults: this.rowSize,
        FilterScope: this.searchBy,
        Filter: this.searchData
      };
      getGames(params)
        .then(res => {
          this.games = res.data.data.rows;
          this.dataCount = res.data.data.total[0].count;
          this.dataLoading = false;
        })
        .catch(err => {
          this.dataLoading = false;
          bus.$emit("requestError", err);
          // this.$Message.error("Failed to get games. Please try again later.");
        });
    },
    remove(data) {
      this.$Modal.confirm({
        title: "Remove Game",
        content: `Are you sure you want to remove game ${data.gameRef.gameTitle} ?`,
        okText: "Remove",
        cancelText: "Cancel",
        onOk: () => {
          this.dataLoading = true;
          deleteGame(data.id)
            .then(res => {
              this.getGameList();
              this.dataLoading = false;
              this.$Message.success(
                `Successfully deleted game ${data.gameRef.gameTitle} !`
              );
            })
            .catch(err => {
              this.dataLoading = false;
              this.$Message.error(
                "Failed to remove game. Please try again later."
              );
            });
        }
      });
    },
    pageChanged(val) {
      this.currentPage = val;
      this.getGameList();
    },
    pageSizeChanged(val) {
      this.rowSize = val;
      this.getGameList();
    },
    showInfo(data, index) {
      this.activeRow = index;
      this.$refs.gameInfoModal.triggerModal(data);
    },
    RowClassName(row, index) {
      if (index === this.activeRow) {
        return "active-table-row";
      }
      return "";
    }
  },
  mounted() {
    this.getGameList();
  }
};
</script>
<style scoped>
.remove-all {
  margin-top: 20px;
  float: right;
}
</style>
<style>
.col-ellipsis .ivu-table-cell span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
